var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyPaste({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3C0.776142 3 1 3.22386 1 3.5V12.5C1 13.8807 2.11929 15 3.5 15H9.5C9.77614 15 10 15.2239 10 15.5C10 15.7761 9.77614 16 9.5 16H3.5C1.567 16 0 14.433 0 12.5V3.5C0 3.22386 0.223858 3 0.5 3ZM11.5 0C12.3284 0 13 0.671573 13 1.5V11.5C13 12.3284 12.3284 13 11.5 13H4.5C3.67157 13 3 12.3284 3 11.5V1.5C3 0.671573 3.67157 4.0266e-09 4.5 0H11.5ZM4.5 1C4.22386 1 4 1.22386 4 1.5V11.5C4 11.7761 4.22386 12 4.5 12H11.5C11.7761 12 12 11.7761 12 11.5V1.5C12 1.22386 11.7761 1 11.5 1H4.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyPaste);
export default __webpack_public_path__ + "static/media/copy-paste.b91173bac127c8898af949b63e021f92.svg";
export { ForwardRef as ReactComponent };